import 'prop-types';
import 'react';
import { jsx } from '@emotion/core';
import { ButtonToolbar, ButtonGroup, Button, Icon } from '@appfolio/react-gears';
import { observer } from 'mobx-react';

var ContextMenu = function ContextMenu(_ref) {
  var pageStore = _ref.pageStore;
  if (!pageStore.contextMenu) return null;
  var copyDisabled = !pageStore.pdfStore.selectedField || !pageStore.contextMenu.onField;
  var pasteDisabled = !pageStore.pdfStore.copiedField;

  var handleCopy = function handleCopy() {
    pageStore.pdfStore.setCopiedField(pageStore.pdfStore.selectedField);
    pageStore.pdfStore.setContextMenu();
  };

  var handlePaste = function handlePaste() {
    var _pageStore$contextMen;

    pageStore.pasteField((_pageStore$contextMen = pageStore.contextMenu) === null || _pageStore$contextMen === void 0 ? void 0 : _pageStore$contextMen.position);
  };

  return jsx(ButtonToolbar, {
    className: "m-0"
  }, jsx(ButtonGroup, {
    vertical: true,
    style: {
      position: 'absolute',
      left: "".concat(pageStore.contextMenu.position.x, "px"),
      top: "".concat(pageStore.contextMenu.position.y, "px")
    }
  }, jsx(Button, {
    onClick: handleCopy,
    disabled: copyDisabled
  }, jsx(Icon, {
    name: "clone",
    className: "mr-2"
  }), "Copy"), jsx(Button, {
    onClick: handlePaste,
    disabled: pasteDisabled
  }, jsx(Icon, {
    name: "clipboard",
    className: "mr-2"
  }), "Paste")));
};

ContextMenu.displayName = "ContextMenu";
var ContextMenu$1 = observer(ContextMenu);
export default ContextMenu$1;